import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_PO_STATUS_LANE_ORDER } from "../../app/purchaseOrder/constants/poBoardStatusLanes";
import { filterOrderByMilestone, sortAllView } from "../utils";

const initialState = {
  boardView: "false",
  allViews: {
    listView: {
      nameOfViews: [],
      allItemsName: [
        "ORDER NAME",
        "ACTIONS",
        "SUPPLIER",
        "FACILITY",
        "CREATE DATE",
        "ETA",
        "CREATED BY",
        "STATUS",
        "SHIPMENTS",
        "TYPE",
        "PO TOTAL",
        "PAYMENTS",
        "OUTSTANDING",
        "PAYMENT STATUS",
      ],
      allViews: {
        "Default View": [
          "ORDER NAME",
          "ACTIONS",
          "SUPPLIER",
          "FACILITY",
          "CREATE DATE",
          "ETA",
          "CREATED BY",
          "STATUS",
          "SHIPMENTS",
          "TYPE",
          "PO TOTAL",
          "PAYMENTS",
          "OUTSTANDING",
          "PAYMENT STATUS",
        ],
      },
    },
    boardView: {
      status: {
        nameOfViews: [],
        allItemsName: [...DEFAULT_PO_STATUS_LANE_ORDER],
        allViews: {
          "Default View": [...DEFAULT_PO_STATUS_LANE_ORDER],
        },
      },
      milestone: {
        nameOfViews: [],
        allItemsName: [],
        allViews: {},
      },
      combined: {
        nameOfViews: [],
        allItemsName: [],
        allViews: {},
      },
    },
  },

  purchaseOrders: { count: 0, results: [] },
  purchaseOrdersParams: { limit: 100, offset: 0 },

  singleView: {},
  milestoneOrders: {},
  milestoneList: [],
  filterShipmentByMilestone: {},
  consignmentMappedById: {},

  allFilterField: [],
  allFilterCondition: [],
  filteredConsignmentByRule: null,
};

const newPurchaseOrderSlice = createSlice({
  name: "newPurchaseOrder",
  initialState,
  reducers: {
    setMilestoneOrdersForPurchase: (state, action) => {
      state.milestoneList = action.payload;
    },

    setAllViewsForPurchase: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      Object.keys(views.list.allViews).forEach(name => {
        const columns = views.list.allViews[name];
        if (!columns.includes("ORDER NAME")) {
          views.list.allViews[name] = ["ORDER NAME", ...columns];
        }
      });

      state.allViews = {
        listView: {
          ...state.allViews.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.allViews.listView.allViews, ...views.list.allViews },
        },
        boardView: {
          status: {
            ...state.allViews.boardView.status,
            nameOfViews: views.status.nameOfList,
            allViews: { ...state.allViews.boardView.status.allViews, ...views.status.allViews },
          },
          milestone: {
            nameOfViews: views.milestone.nameOfList,
            allViews: views.milestone.allViews,
          },
          combined: {
            nameOfViews: views.combined.nameOfList,
            allViews: views.combined.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
    handleFilterPurchaseByMilestone: (state, action) => {
      const { filterd, mapConsignments } = filterOrderByMilestone(
        action.payload,
        state.milestoneList,
      );
      state.consignmentMappedById = mapConsignments;
      state.filterShipmentByMilestone = filterd;
    },
    updateFilterPurchaseByMilestone: (state, action) => {
      const filterd = { ...state.filterShipmentByMilestone };
      const sourceKey = action.payload.sourceIndex;
      const destinationKey = action.payload.id;
      const movedId = action.payload.data?.ids?.[0];
      if (movedId == null || sourceKey == null || destinationKey == null) {
        return;
      }
      filterd[sourceKey] = (filterd[sourceKey] || []).filter(item => item !== movedId);
      filterd[destinationKey] = [movedId, ...(filterd[destinationKey] || [])];
      state.filterShipmentByMilestone = filterd;
    },
    setListOfStatusForDefaultViewForPurchase: (state, action) => {
      state.allViews.boardView.status.allViews["Default View"] = action.payload;
    },
  },
});

export const {
  setMilestoneOrders,
  setAllViewsForPurchase,
  setMilestoneOrdersForPurchase,
  handleFilterPurchaseByMilestone,
  updateFilterPurchaseByMilestone,
  setListOfStatusForDefaultViewForPurchase,
} = newPurchaseOrderSlice.actions;

export default newPurchaseOrderSlice.reducer;
